import { GetPlayerProfileResponse } from 'services/players';

export const getHeroPlayerProps = (data: GetPlayerProfileResponse) => ({
	isManager: data.isManager,
	isEsports: data.team === 'esports',
	isMensTeam: data.isMensTeam,
	isEdsTeam: data.isEdsTeam,
	isAcademyTeam: data.isAcademyTeam,
	firstName: data.firstName,
	lastName: data.lastName,
	number: data.shirtNumber,
	country: data.country,
	flagUri: data.flagUri,
	position: data.position,
	dateOfBirth: data.dateOfBirth,
	halfBodyImageUri: data.halfBodyImageUri,
	isWomensTeam: data.isWomensTeam,
	mobileBackgroundImageUri: data.isManager
		? data.teamPlayerImages?.managerHeroMobileImage
		: data.teamPlayerImages?.playerHeroMobileImage ||
			data.playerHeroMobileImage,
	desktopBackgroundImageUri: data.isManager
		? data.teamPlayerImages?.managerHeroDesktopImage
		: data.teamPlayerImages?.playerHeroDesktopImage ||
			data.playerHeroDesktopImage,
	shopCtaLink: data.shopCtaLink,
});
